import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23c2211f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = {
  key: 0,
  class: "card-action float-end"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-cog me-2" }),
  /*#__PURE__*/_createTextVNode("จัดการข้อมูล ")
], -1))
const _hoisted_5 = { class: "dropdown-menu" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-edit me-2" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-paperclip me-2" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-image me-2" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-calendar-times me-2" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-ban me-2" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-file-alt me-2" }),
  /*#__PURE__*/_createTextVNode("การจัดหา/จัดซื้อ/จัดจ้าง")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "card-subtitle text-muted" }, "แสดงข้อมูลรายละเอียดผลการดำเนินการการจัดหา/จัดซื้อ/จัดจ้าง ของโครงการ", -1))
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = { class: "mb-3 pt-2" }
const _hoisted_16 = { class: "card card-sub" }
const _hoisted_17 = { class: "card-body mb-0 pb-0" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-calendar-alt me-2" }),
  /*#__PURE__*/_createTextVNode("วันที่ได้รับงบประมาณ:")
], -1))
const _hoisted_19 = { class: "text-muted" }
const _hoisted_20 = { class: "mb-3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-file me-2" }),
  /*#__PURE__*/_createTextVNode("ข้อมูลการจัดหา/จัดซื้อ/จัดจ้าง:")
], -1))
const _hoisted_22 = { class: "card card-sub mt-2 mb-3" }
const _hoisted_23 = { class: "card-body pb-0" }
const _hoisted_24 = { class: "mb-3" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-hand-holding-usd me-2" }),
  /*#__PURE__*/_createTextVNode("วิธีการจัดหา:")
], -1))
const _hoisted_26 = { class: "text-muted" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-sm-6" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-university me-2" }),
  /*#__PURE__*/_createTextVNode("หน่วยงานที่รับผิดชอบ:")
], -1))
const _hoisted_30 = { class: "text-muted" }
const _hoisted_31 = { class: "col-sm-6" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-map-marker me-2" }),
  /*#__PURE__*/_createTextVNode("สถานที่ดำเนินงานโครงการ:")
], -1))
const _hoisted_33 = { class: "text-muted" }
const _hoisted_34 = { class: "col-sm-6" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-calendar me-2" }),
  /*#__PURE__*/_createTextVNode("วันที่เริ่มโครงการ:")
], -1))
const _hoisted_36 = { class: "text-muted" }
const _hoisted_37 = { class: "col-sm-6" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-paperclip me-2" }),
  /*#__PURE__*/_createTextVNode("เอกสารการจัดหา/จัดซื้อ/จัดจ้าง:")
], -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-list me-2" }),
  /*#__PURE__*/_createTextVNode("รายละเอียด:")
], -1))
const _hoisted_40 = { class: "text-muted" }
const _hoisted_41 = { class: "row mb-3" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-coins me-2" }),
  /*#__PURE__*/_createTextVNode("ข้อมูลงบประมาณ:")
], -1))
const _hoisted_43 = { class: "card card-sub mt-2" }
const _hoisted_44 = { class: "card-body" }
const _hoisted_45 = { class: "mb-3" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-dollar-sign me-2" }),
  /*#__PURE__*/_createTextVNode("งบกลางที่ได้รับจัดสรร:")
], -1))
const _hoisted_47 = { class: "text-muted" }
const _hoisted_48 = { class: "mb-3" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-check me-2" }),
  /*#__PURE__*/_createTextVNode("งบประมาณที่ใช้จริง:")
], -1))
const _hoisted_50 = { class: "text-muted" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-piggy-bank me-2" }),
  /*#__PURE__*/_createTextVNode("งบประมาณส่วนต่าง:")
], -1))
const _hoisted_52 = { class: "text-muted mb-0" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-flag-checkered me-2" }),
  /*#__PURE__*/_createTextVNode("ข้อมูลระยะเวลาดำเนินการ:")
], -1))
const _hoisted_54 = { class: "card card-sub mt-2" }
const _hoisted_55 = { class: "card-body" }
const _hoisted_56 = { class: "mb-3" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-calendar-times me-2" }),
  /*#__PURE__*/_createTextVNode("วันที่สิ้นสุดโครงการ:")
], -1))
const _hoisted_58 = { class: "mb-3" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-clock me-2" }),
  /*#__PURE__*/_createTextVNode("ระยะเวลาดำเนินการ:")
], -1))
const _hoisted_60 = { class: "text-muted mb-0" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-hourglass me-2" }),
  /*#__PURE__*/_createTextVNode("เหลือเวลา:")
], -1))
const _hoisted_62 = { class: "text-muted mb-0" }
const _hoisted_63 = {
  key: 1,
  class: "text-center"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-file-alt me-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectProcureFormComponent = _resolveComponent("ProjectProcureFormComponent")!
  const _component_ProjectProcureEndDateModalComponent = _resolveComponent("ProjectProcureEndDateModalComponent")!
  const _component_ProjectProcureEndDateFormComponent = _resolveComponent("ProjectProcureEndDateFormComponent")!
  const _component_ProjectProcureAttachmentModalComponent = _resolveComponent("ProjectProcureAttachmentModalComponent")!
  const _component_ProjectProcureAttachmentFormComponent = _resolveComponent("ProjectProcureAttachmentFormComponent")!
  const _component_ProjectProcureImageModalComponent = _resolveComponent("ProjectProcureImageModalComponent")!
  const _component_ProjectProcureEndDateOffcanvasComponent = _resolveComponent("ProjectProcureEndDateOffcanvasComponent")!
  const _component_ProjectProcureAttachmentOffcanvasComponent = _resolveComponent("ProjectProcureAttachmentOffcanvasComponent")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isProcured || (_ctx.canEdit && _ctx.isStarted && !_ctx.isCanceled && !_ctx.isFinished))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.isProcured && _ctx.canEdit && !_ctx.isCanceled && !_ctx.isFinished)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("ul", _hoisted_5, [
                    _createElementVNode("li", null, [
                      _createElementVNode("button", {
                        class: "dropdown-item",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.editClick && _ctx.editClick(...args)))
                      }, [
                        _hoisted_6,
                        _createTextVNode("แก้ไขการจัดหา/จัดซื้อ/จัดจ้าง ")
                      ])
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("button", {
                        class: "dropdown-item",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.attachmentClick && _ctx.attachmentClick(...args)))
                      }, [
                        _hoisted_7,
                        _createTextVNode("จัดการเอกสารแนบ ")
                      ])
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("button", {
                        class: "dropdown-item",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.imageClick && _ctx.imageClick(...args)))
                      }, [
                        _hoisted_8,
                        _createTextVNode("จัดการรูปภาพประกอบ ")
                      ])
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("button", {
                        class: "dropdown-item",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.endDateClick && _ctx.endDateClick(...args)))
                      }, [
                        _hoisted_9,
                        _createTextVNode("จัดการระยะเวลาดำเนินการ ")
                      ])
                    ]),
                    (_ctx.project?.projectStatus.key === 2)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_10,
                          _createElementVNode("li", null, [
                            _createElementVNode("button", {
                              class: "dropdown-item",
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.deleteClick && _ctx.deleteClick(...args)))
                            }, [
                              _hoisted_11,
                              _createTextVNode("ลบการจัดหา/จัดซื้อ/จัดจ้าง ")
                            ])
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            _hoisted_12,
            _hoisted_13
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_ctx.isProcured)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", null, [
                          _hoisted_18,
                          _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.procure?.receiveBudgetDate ? _ctx.thaiDate(_ctx.procure?.receiveBudgetDate) : ''), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _hoisted_25,
                          _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.procure?.provideType.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _hoisted_29,
                            _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.procure?.projectOwner), 1)
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _hoisted_32,
                            _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.procure?.location), 1)
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _hoisted_35,
                            _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.procure?.startDate ? _ctx.thaiDate(_ctx.procure?.startDate) : ''), 1)
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            _hoisted_38,
                            _createElementVNode("p", null, [
                              _createElementVNode("a", {
                                href: "#",
                                onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showAttachment && _ctx.showAttachment(...args)), ["stop","prevent"]))
                              }, " ดูเอกสารการจัดหา/จัดซื้อ/จัดจ้าง ")
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_39,
                            _withDirectives(_createElementVNode("p", _hoisted_40, null, 512), [
                              [_directive_dompurify_html, _ctx.procure?.remark ? _ctx.procure?.remark.replace(/(?:\r\n|\r|\n)/g, '<br />') : '-']
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", {
                      class: _normalizeClass({'col-sm-12': _ctx.procure?.provideType.id === 13, 'col-sm-6': _ctx.procure?.provideType.id !== 13})
                    }, [
                      _hoisted_42,
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, [
                            _hoisted_46,
                            _createElementVNode("p", _hoisted_47, _toDisplayString(Number(_ctx.project?.projectBudgets.filter(m => m.id !== 4).reduce((total, m) => total + (m.amount ? m.amount : 0), 0)).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + " บาท ", 1)
                          ]),
                          _createElementVNode("div", _hoisted_48, [
                            _hoisted_49,
                            _createElementVNode("p", _hoisted_50, _toDisplayString(Number(_ctx.procure?.realBudget).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + " บาท ", 1)
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_51,
                            _createElementVNode("p", _hoisted_52, _toDisplayString(Number(_ctx.project?.projectBudgets.filter(m => m.id !== 4).reduce((total, m) => total + (m.amount ? m.amount : 0), 0) - _ctx.procure?.realBudget).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + " บาท ", 1)
                          ])
                        ])
                      ])
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["col-sm-6", {'d-none': _ctx.procure?.provideType.id === 13}])
                    }, [
                      _hoisted_53,
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("div", _hoisted_56, [
                            _hoisted_57,
                            _createElementVNode("p", null, [
                              _createElementVNode("a", {
                                href: "#",
                                onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showEndDate && _ctx.showEndDate(...args)), ["stop","prevent"]))
                              }, _toDisplayString(_ctx.procure?.endDates ? _ctx.thaiDate(_ctx.procure?.endDates.find(m => m.status).endDate) : ''), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_58, [
                            _hoisted_59,
                            _createElementVNode("p", _hoisted_60, _toDisplayString(_ctx.procure?.endDates ? _ctx.dateDiff(_ctx.procure?.endDates.find(m => m.status).endDate, _ctx.procure?.startDate) : '0') + " วัน", 1)
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_61,
                            _createElementVNode("p", _hoisted_62, _toDisplayString(!_ctx.isCompleted ? (_ctx.procure?.endDates ? `${_ctx.dateDiff(_ctx.procure?.endDates.find(m => m.status).endDate, new Date())} วัน` : '0 วัน') : '-'), 1)
                          ])
                        ])
                      ])
                    ], 2)
                  ])
                ], 64))
              : (!_ctx.isCanceled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.createClick && _ctx.createClick(...args)))
                    }, [
                      _hoisted_64,
                      _createTextVNode("เพิ่มข้อมูลการจัดหา/จัดซื้อ/จัดจ้าง ")
                    ])
                  ]))
                : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ProjectProcureFormComponent, {
      ref: "projectProcureForm",
      "project-id": _ctx.projectId,
      onRefresh: _ctx.refresh
    }, null, 8, ["project-id", "onRefresh"]),
    _createVNode(_component_ProjectProcureEndDateModalComponent, {
      ref: "endDateModal",
      "project-id": _ctx.projectId,
      onCreate: _ctx.createEndDateClick,
      onEdit: _ctx.editEndDateClick
    }, null, 8, ["project-id", "onCreate", "onEdit"]),
    _createVNode(_component_ProjectProcureEndDateFormComponent, {
      ref: "endDateForm",
      "project-id": _ctx.projectId,
      "end-date-id": _ctx.selectedEndDate,
      onHidden: _ctx.endDateClose
    }, null, 8, ["project-id", "end-date-id", "onHidden"]),
    _createVNode(_component_ProjectProcureAttachmentModalComponent, {
      ref: "attachmentModal",
      "project-id": _ctx.projectId,
      onUpload: _ctx.uploadClick
    }, null, 8, ["project-id", "onUpload"]),
    _createVNode(_component_ProjectProcureAttachmentFormComponent, {
      ref: "attachmentForm",
      "project-id": _ctx.projectId,
      onHidden: _ctx.formHidden
    }, null, 8, ["project-id", "onHidden"]),
    _createVNode(_component_ProjectProcureImageModalComponent, {
      ref: "imageModal",
      "project-id": _ctx.projectId
    }, null, 8, ["project-id"]),
    _createVNode(_component_ProjectProcureEndDateOffcanvasComponent, {
      ref: "endDateOffcanvas",
      "project-id": _ctx.projectId
    }, null, 8, ["project-id"]),
    _createVNode(_component_ProjectProcureAttachmentOffcanvasComponent, {
      ref: "attachmentOffcanvas",
      "project-id": _ctx.projectId
    }, null, 8, ["project-id"])
  ], 64))
}